import { render, staticRenderFns } from "./DiceResultModal.vue?vue&type=template&id=b489edce&scoped=true&"
import script from "./DiceResultModal.vue?vue&type=script&lang=js&"
export * from "./DiceResultModal.vue?vue&type=script&lang=js&"
import style0 from "./DiceResultModal.vue?vue&type=style&index=0&id=b489edce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b489edce",
  null
  
)

export default component.exports